import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ConfigProvider } from "./config.service";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({
  providedIn: "root",
})
export class ComplaintService {
  config: object;
  private tokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(configProvider: ConfigProvider, private http: HttpClient) {
    this.config = configProvider.getConfig();
  }

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  getAuthToken(): Observable<any> {
    let body = new URLSearchParams();
    body.set("grant_type", "client_credentials");
    body.set("client_id", "complaints-client");
    body.set("client_secret", "g9f5RUuVatvXzJIpUFpCkVxKKIA2oSQb");
    let options = {
      headers: new HttpHeaders().set("Content-Type", "application/x-www-form-urlencoded"),
    };
    return this.http
      .post("https://auth.aldagi.ge/realms/aldagi-complaints/protocol/openid-connect/token", body.toString(), options)
      .pipe(map(this.extractData))
      .pipe(
        map((data: any) => {
          const token = data.access_token;
          localStorage.setItem("token", JSON.stringify(data.access_token));
          this.tokenSubject.next(token);
          return data;
        })
      );
  }

  public getToken(): Observable<string | null> {
    const token = localStorage.getItem('token');
    if (token) {
      this.tokenSubject.next(token.replace(/"/g, ''));
    }
    return this.tokenSubject.asObservable();
  }


  registerComplaint(requestData: any): Observable<any> {
    return this.getToken().pipe(
      map(token => {
        const headers = new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        });
        return { headers };
      }),
      switchMap(httpOptionsWithToken =>
        this.http
          .post(
            this.config["API_BASE"] + "/api/Complaints/register-complaint",
            requestData,
            httpOptionsWithToken
          )
      ),
      map(this.extractData)
    );
  }


  getSignedComplaint(complaintId: number) {
    return this.http.get(this.config["API_BASE"] + "/api/Complaints/signed-complaint/" + complaintId, {
      responseType: "arraybuffer" as "json",
    });
  }
}
